import { useGameStore } from "../stores/gameStore.js";
import { tickFight } from "./fightLoop.js";
import { tickStatusEffects } from "./statusEffectLoop.js";
import { tickWorkflow } from "./workflowLoop.js";

let isRunning = false;
let intervalId = null;

function tick() {
  const game = useGameStore();
  if (game.isPaused) return;
  
  tickStatusEffects();
  tickFight();
  tickWorkflow();
}

export function startGameLoop() {
  if (isRunning) return;
  isRunning = true;
  intervalId = setInterval(tick, 1000 / 60);
}

export function stopGameLoop() {
  isRunning = false;
  clearInterval(intervalId);
}
